import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: 
      `advanced-filter inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2`
     }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = {
  class: "absolute inset-y-0 right-0 flex items-center px-4",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = {
  class: "absolute z-50 mt-2 right-0 bg-white",
  style: {"width":"300px"}
}
const _hoisted_5 = {
  class: 
          `select w-full bg-white absolute border border-gray-lp-400 rounded-lg overflow-x-show pt-1`
        ,
  style: {"max-height":"80vh"}
}
const _hoisted_6 = {
  key: 0,
  class: "px-1 py-3 mx-4"
}
const _hoisted_7 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_8 = { class: "flex flex-row justify-between items-center w-full px-3 py-2 bg-white border border-gray-lp-400 rounded-lg cursor-pointer text-12px xxl:text-14px" }
const _hoisted_9 = { class: "px-1 py-3 mx-4" }
const _hoisted_10 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_11 = { class: "px-1 py-3 mx-4" }
const _hoisted_12 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_13 = { class: "px-1 py-3 mx-4" }
const _hoisted_14 = { class: "font-semibold text-gray-lp-300 text-12px xxl:text-14px mb-2" }
const _hoisted_15 = { class: "flex sticky bottom-0 px-4 pt-1 pb-2 rounded-b-md border-t border-gray-lp-400 bg-white" }
const _hoisted_16 = { class: "w-6/12 pl-2 pr-1 mt-2" }
const _hoisted_17 = { class: "w-6/12 pr-2 pl-1 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "bg-white rounded-md border border-gray-lp-400 text-black-lp-300 leading-tight px-4 py-2.5 xxl:py-2.5 pr-8 font-normal relative",
      style: {"cursor":"pointer","width":"120px"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", null, _toDisplayString(_ctx.$t("bulkBooking.filter.label")), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock(_component_Icons, {
              key: 0,
              width: "16",
              height: "16",
              name: "chevron-up-new",
              color: "#4D4D4D"
            }))
          : (_openBlock(), _createBlock(_component_Icons, {
              key: 1,
              width: "16",
              height: "16",
              name: "chevron-down-new",
              color: "#4D4D4D",
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          )
            }))
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _withDirectives(_createVNode("div", _hoisted_5, [
        (!_ctx.isClient)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("bulkBooking.filter.date")), 1),
              _createVNode(_component_TimeRangePicker, {
                "data-testid": "bulk-booking-filter-date-range",
                class: "w-full bulk-booking-calendar",
                onSelect: _ctx.setPeriode,
                isCloseDateAfterSelect: "",
                default: _ctx.$t('custom'),
                highlightOnSelected: true,
                customCalendar: true,
                advanceStyle: {
              width: '550px',
              fontSize: 'text-sm',
              fontWeight: 'font-medium'
            },
                customTotalMaxDate: 30,
                resetLimitOnSetOption: "",
                isDateAlignCenter: "",
                maxDate: new Date(),
                isSetMaxDate: "",
                startDate: _ctx.startDate,
                endDate: _ctx.endDate,
                ref: "timeRangePicker"
              }, {
                trigger: _withCtx(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("span", {
                      class: 
                    _ctx.startDate && _ctx.endDate
                      ? 'text-black-lp-300'
                      : 'text-gray-lp-600'
                  
                    }, _toDisplayString(_ctx.startDate && _ctx.endDate
                      ? `${_ctx.formatDateWithoutTime(
                          _ctx.startDate
                        )} - ${_ctx.formatDateWithoutTime(_ctx.endDate)}`
                      : "Pilih rentang tanggal"), 3),
                    _createVNode(_component_Icons, {
                      name: "chevron-down-new",
                      width: "16",
                      height: "16",
                      color: "#4D4D4D"
                    })
                  ])
                ]),
                _: 1
              }, 8, ["onSelect", "default", "maxDate", "startDate", "endDate"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("bulkBooking.filter.uploadStatus")), 1),
          _createVNode(_component_Select, {
            dataSelect: _ctx.uploadStatusOptions,
            onOpenSelect: _ctx.onOpenUploadStatus,
            onCloseSelect: _ctx.onCloseUploadStatus,
            onChooseSelect: _ctx.onSelectUploadStatus,
            value: _ctx.filterData.uploadStatus.value,
            isOpenMenu: _ctx.uploadStatusSelect,
            class: "w-full text-12px xxl:text-14px"
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bulkBooking.filter.fileType")), 1),
          _createVNode(_component_Select, {
            dataSelect: _ctx.formTypeOptions,
            onOpenSelect: _ctx.onOpenFormType,
            onCloseSelect: _ctx.onCloseFormType,
            onChooseSelect: _ctx.onSelectFormType,
            value: _ctx.filterData.formType.value,
            isOpenMenu: _ctx.formTypeSelect,
            class: "w-full text-12px xxl:text-14px",
            isDisabled: _ctx.isClient
          }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "isDisabled"])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("bulkBooking.filter.createdFor")), 1),
          _createVNode(_component_SelectSearchV2, {
            onChevron: _cache[3] || (_cache[3] = (e) => (_ctx.isChevron = e)),
            options: _ctx.posClientList,
            onFilter: _ctx.fetchPosClient,
            onFocus: _cache[4] || (_cache[4] = () => _ctx.fetchPosClient('')),
            isLoading: _ctx.isLoadingPosClient,
            onChange: _ctx.onSelectCreatedFor,
            keyName: "name",
            keyValue: "id",
            modelValue: _ctx.filterData.createdFor,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData.createdFor = $event)),
            placeholder: _ctx.$t('bulkBooking.filter.placeholderClientPos'),
            key: _ctx.resetSelectSearch,
            isDisabled: _ctx.isClient,
            inputStyling: "text-12px xxl:text-14px"
          }, null, 8, ["options", "onFilter", "isLoading", "onChange", "modelValue", "placeholder", "isDisabled"])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_LpButton, {
              color: "white",
              textColor: "red-lp-100",
              title: _ctx.$t('bulkBooking.filter.reset'),
              customClass: "border border-white",
              outline: "",
              fontWeight: "semibold",
              onClick: _ctx.resetToDefaultFilter,
              isWidthFull: ""
            }, null, 8, ["title", "onClick"])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode(_component_LpButton, {
              color: "red-lp-100",
              textColor: "white",
              title: _ctx.$t('bulkBooking.filter.apply'),
              fontWeight: "semibold",
              onClick: _ctx.applyFilter,
              isWidthFull: ""
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ], 512), [
        [_vShow, _ctx.openFilter]
      ])
    ], 512), [
      [_vShow, _ctx.openFilter]
    ])
  ], 512)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.$emit('opened', false);
          _ctx.openFilter = false;
        }
      }
    ]
  ])
}